export interface LiveRadioProgram {
  id: number;
  name: string;
  host: string;
  startTime: string;
  endTime: string;
}

export interface LiveRadioBroadcaster {
  id: number;
  name: string;
  role: string;
  photoUrl: string;
}

export interface LiveRadio {
  id: number;
  name: string;
  frequency: string;
  category: string;
  activityScore: number;
  interactionScore: number;
  currentListeners: number;
  programs: LiveRadioProgram[];
  broadcasters: LiveRadioBroadcaster[];
  status: 'on-air' | 'live-event' | 'live-show' | 'special';
  upTime: string;
  chatMsgCount: number;
  lastInteraction: string;
  thumbnailUrl: string;
}

export const liveRadios: LiveRadio[] = [
  {
    id: 1,
    name: 'Radio Deportiva Total',
    frequency: '102.7 FM',
    category: 'Deportes',
    activityScore: 94,
    interactionScore: 87,
    currentListeners: 4820,
    status: 'live-event',
    upTime: '6h 42m',
    chatMsgCount: 2340,
    lastInteraction: 'hace 12s',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20radio%20studio%20with%20modern%20broadcasting%20equipment%20energetic%20atmosphere%20warm%20amber%20lighting%20professional%20microphones%20and%20mixing%20console%20sport%20memorabilia%20on%20walls%20clean%20contemporary%20design&width=160&height=160&seq=sa57-radio-thumb-01&orientation=squarish',
    programs: [
      { id: 1, name: 'Carrusel Deportivo', host: 'Javier Mendoza', startTime: '14:00', endTime: '18:00' },
      { id: 2, name: 'Goles y Marcadores', host: 'Carlos Herrera', startTime: '12:00', endTime: '14:00' },
    ],
    broadcasters: [
      { id: 1, name: 'Javier Mendoza', role: 'Locutor Principal', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20male%20sports%20broadcaster%20in%20studio%20charismatic%20expression%20casual%20but%20polished%20look%20warm%20lighting%20clean%20background&width=160&height=160&seq=sa57-bc-01&orientation=squarish' },
      { id: 2, name: 'Carlos Herrera', role: 'Comentarista', photoUrl: 'https://readdy.ai/api/search-image?query=Experienced%20male%20sports%20commentator%20with%20headset%20on%20focused%20expression%20studio%20background%20professional%20look%20neutral%20tones&width=160&height=160&seq=sa57-bc-02&orientation=squarish' },
      { id: 3, name: 'Daniel Ortega', role: 'Analista', photoUrl: 'https://readdy.ai/api/search-image?query=Young%20male%20sports%20analyst%20at%20broadcast%20desk%20modern%20casual%20style%20clean%20studio%20setting%20confident%20pose%20natural%20light&width=160&height=160&seq=sa57-bc-03&orientation=squarish' },
    ],
  },
  {
    id: 2,
    name: 'Estéreo Capital',
    frequency: '98.3 FM',
    category: 'Música / Entretenimiento',
    activityScore: 91,
    interactionScore: 92,
    currentListeners: 4190,
    status: 'on-air',
    upTime: '5h 18m',
    chatMsgCount: 3180,
    lastInteraction: 'hace 8s',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20music%20radio%20studio%20with%20colorful%20neon%20accents%20modern%20DJ%20setup%20vinyl%20records%20on%20walls%20warm%20and%20cool%20lighting%20mix%20contemporary%20urban%20aesthetic&width=160&height=160&seq=sa57-radio-thumb-02&orientation=squarish',
    programs: [
      { id: 3, name: 'Capital Mix', host: 'Felipe Gutiérrez', startTime: '15:00', endTime: '19:00' },
    ],
    broadcasters: [
      { id: 4, name: 'Felipe Gutiérrez', role: 'DJ / Locutor', photoUrl: 'https://readdy.ai/api/search-image?query=Stylish%20male%20radio%20DJ%20in%20modern%20studio%20headphones%20around%20neck%20confident%20smile%20urban%20fashion%20style%20neon%20ambient%20light&width=160&height=160&seq=sa57-bc-04&orientation=squarish' },
      { id: 5, name: 'María José Salazar', role: 'Co-Locutora', photoUrl: 'https://readdy.ai/api/search-image?query=Elegant%20female%20radio%20co-host%20at%20studio%20desk%20warm%20smile%20professional%20attire%20soft%20studio%20lighting%20clean%20composition&width=160&height=160&seq=sa57-bc-05&orientation=squarish' },
    ],
  },
  {
    id: 3,
    name: 'Radio Élite Digital',
    frequency: '101.1 FM',
    category: 'Tecnología / Cultura',
    activityScore: 88,
    interactionScore: 90,
    currentListeners: 3850,
    status: 'live-show',
    upTime: '3h 55m',
    chatMsgCount: 2760,
    lastInteraction: 'hace 5s',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Modern%20digital%20radio%20studio%20with%20large%20screens%20displaying%20data%20sleek%20minimalist%20design%20cool%20white%20ambient%20lighting%20high%20tech%20broadcasting%20equipment%20podcast%20setup&width=160&height=160&seq=sa57-radio-thumb-03&orientation=squarish',
    programs: [
      { id: 4, name: 'Mundo Digital', host: 'Isabella Torres', startTime: '16:00', endTime: '20:00' },
    ],
    broadcasters: [
      { id: 6, name: 'Isabella Torres', role: 'Host Principal', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20tech%20radio%20host%20in%20modern%20studio%20glasses%20smart%20casual%20outfit%20confident%20and%20approachable%20clean%20lighting&width=160&height=160&seq=sa57-bc-06&orientation=squarish' },
      { id: 7, name: 'Santiago López', role: 'Productor al Aire', photoUrl: 'https://readdy.ai/api/search-image?query=Young%20male%20radio%20producer%20with%20laptop%20focused%20on%20screen%20studio%20headphones%20modern%20workspace%20clean%20desk%20setup&width=160&height=160&seq=sa57-bc-07&orientation=squarish' },
    ],
  },
  {
    id: 4,
    name: 'Radio Peninsular',
    frequency: '95.5 FM',
    category: 'Regional / Noticias',
    activityScore: 85,
    interactionScore: 78,
    currentListeners: 3120,
    status: 'on-air',
    upTime: '8h 10m',
    chatMsgCount: 1890,
    lastInteraction: 'hace 45s',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Regional%20news%20radio%20station%20with%20warm%20traditional%20vibes%20wood%20paneled%20studio%20professional%20microphones%20map%20of%20the%20region%20on%20wall%20soft%20natural%20light%20through%20windows&width=160&height=160&seq=sa57-radio-thumb-04&orientation=squarish',
    programs: [
      { id: 5, name: 'Noticias Regionales', host: 'Adriana Mejía', startTime: '10:00', endTime: '18:00' },
    ],
    broadcasters: [
      { id: 8, name: 'Adriana Mejía', role: 'Periodista / Locutora', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20news%20anchor%20in%20radio%20studio%20with%20papers%20and%20microphone%20warm%20engaging%20expression%20journalistic%20style%20natural%20light&width=160&height=160&seq=sa57-bc-08&orientation=squarish' },
      { id: 9, name: 'Gabriel Paredes', role: 'Editor al Aire', photoUrl: 'https://readdy.ai/api/search-image?query=Experienced%20male%20radio%20editor%20at%20control%20desk%20monitors%20behind%20professional%20demeanor%20studio%20headphones%20clean%20workspace&width=160&height=160&seq=sa57-bc-09&orientation=squarish' },
    ],
  },
  {
    id: 5,
    name: 'Radio Industria',
    frequency: '107.3 FM',
    category: 'Negocios / Industria',
    activityScore: 82,
    interactionScore: 75,
    currentListeners: 2960,
    status: 'on-air',
    upTime: '7h 35m',
    chatMsgCount: 1520,
    lastInteraction: 'hace 1m',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Professional%20business%20radio%20studio%20with%20corporate%20aesthetic%20leather%20chairs%20financial%20data%20screens%20sophisticated%20dark%20wood%20and%20metal%20design%20warm%20task%20lighting&width=160&height=160&seq=sa57-radio-thumb-05&orientation=squarish',
    programs: [
      { id: 6, name: 'Economía al Día', host: 'Camila Restrepo', startTime: '11:00', endTime: '17:00' },
    ],
    broadcasters: [
      { id: 10, name: 'Camila Restrepo', role: 'Conductora', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20business%20radio%20host%20corporate%20attire%20confident%20presence%20at%20broadcast%20desk%20modern%20studio%20setting%20warm%20light&width=160&height=160&seq=sa57-bc-10&orientation=squarish' },
      { id: 11, name: 'Roberto Silva', role: 'Analista Financiero', photoUrl: 'https://readdy.ai/api/search-image?query=Male%20financial%20analyst%20in%20radio%20studio%20reviewing%20data%20on%20tablet%20professional%20business%20casual%20look%20clean%20workspace&width=160&height=160&seq=sa57-bc-11&orientation=squarish' },
    ],
  },
  {
    id: 6,
    name: 'Radio Éxito FM',
    frequency: '93.7 FM',
    category: 'Música / Variedades',
    activityScore: 92,
    interactionScore: 95,
    currentListeners: 5210,
    status: 'live-show',
    upTime: '4h 20m',
    chatMsgCount: 3920,
    lastInteraction: 'hace 3s',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=High%20energy%20variety%20radio%20studio%20with%20colorful%20LED%20panels%20modern%20DJ%20booth%20neon%20signs%20concert%20style%20lighting%20energetic%20and%20youthful%20atmosphere&width=160&height=160&seq=sa57-radio-thumb-06&orientation=squarish',
    programs: [
      { id: 7, name: 'Éxito Total', host: 'Andrés Murillo', startTime: '15:30', endTime: '20:00' },
    ],
    broadcasters: [
      { id: 12, name: 'Andrés Murillo', role: 'DJ Estrella', photoUrl: 'https://readdy.ai/api/search-image?query=Energetic%20male%20radio%20DJ%20in%20vibrant%20studio%20headphones%20on%20dynamic%20pose%20street%20style%20fashion%20neon%20lights%20colorful%20background&width=160&height=160&seq=sa57-bc-12&orientation=squarish' },
      { id: 13, name: 'Natalia Córdoba', role: 'Co-Host', photoUrl: 'https://readdy.ai/api/search-image?query=Charismatic%20female%20radio%20co-host%20laughing%20modern%20casual%20style%20microphone%20in%20hand%20colorful%20studio%20background%20warm%20lighting&width=160&height=160&seq=sa57-bc-13&orientation=squarish' },
      { id: 14, name: 'Paola Rincón', role: 'Productora Musical', photoUrl: 'https://readdy.ai/api/search-image?query=Female%20music%20producer%20at%20studio%20console%20focused%20on%20mixing%20creative%20atmosphere%20headphones%20around%20neck%20modern%20studio&width=160&height=160&seq=sa57-bc-14&orientation=squarish' },
    ],
  },
  {
    id: 7,
    name: 'Radio Vallenata',
    frequency: '99.1 FM',
    category: 'Música Regional',
    activityScore: 76,
    interactionScore: 82,
    currentListeners: 2380,
    status: 'on-air',
    upTime: '5h 50m',
    chatMsgCount: 1640,
    lastInteraction: 'hace 30s',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Warm%20traditional%20Colombian%20music%20radio%20studio%20acoustic%20guitar%20on%20wall%20colorful%20cultural%20decorations%20wooden%20furniture%20soft%20amber%20lighting%20folk%20art%20elements&width=160&height=160&seq=sa57-radio-thumb-07&orientation=squarish',
    programs: [
      { id: 8, name: 'Sabor Vallenato', host: 'Valeria Duque', startTime: '13:00', endTime: '19:00' },
    ],
    broadcasters: [
      { id: 15, name: 'Valeria Duque', role: 'Locutora Principal', photoUrl: 'https://readdy.ai/api/search-image?query=Warm%20female%20radio%20host%20in%20traditional%20style%20studio%20colorful%20blouse%20genuine%20smile%20cultural%20ambiance%20soft%20lighting&width=160&height=160&seq=sa57-bc-15&orientation=squarish' },
      { id: 16, name: 'Mateo Álvarez', role: 'Musicalizador', photoUrl: 'https://readdy.ai/api/search-image?query=Young%20male%20music%20programmer%20at%20radio%20console%20casual%20style%20creative%20workspace%20with%20music%20posters%20warm%20light&width=160&height=160&seq=sa57-bc-16&orientation=squarish' },
    ],
  },
  {
    id: 8,
    name: 'Radio Caribe FM',
    frequency: '103.9 FM',
    category: 'Entretenimiento / Cultura',
    activityScore: 79,
    interactionScore: 84,
    currentListeners: 2640,
    status: 'live-event',
    upTime: '4h 5m',
    chatMsgCount: 1980,
    lastInteraction: 'hace 18s',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Tropical%20themed%20radio%20studio%20with%20bamboo%20and%20natural%20wood%20accents%20turquoise%20and%20coral%20color%20palette%20island%20vibe%20modern%20broadcast%20equipment%20beach%20culture%20aesthetic&width=160&height=160&seq=sa57-radio-thumb-08&orientation=squarish',
    programs: [
      { id: 9, name: 'Ritmo Caribeño', host: 'Carmen Díaz', startTime: '16:00', endTime: '20:00' },
    ],
    broadcasters: [
      { id: 17, name: 'Carmen Díaz', role: 'Presentadora', photoUrl: 'https://readdy.ai/api/search-image?query=Charismatic%20female%20Caribbean%20radio%20host%20colorful%20outfit%20warm%20tropical%20vibe%20professional%20studio%20setting%20bright%20natural%20light&width=160&height=160&seq=sa57-bc-17&orientation=squarish' },
    ],
  },
  {
    id: 9,
    name: 'Radio Rock Nacional',
    frequency: '96.5 FM',
    category: 'Música / Rock',
    activityScore: 84,
    interactionScore: 89,
    currentListeners: 3450,
    status: 'live-show',
    upTime: '3h 40m',
    chatMsgCount: 2850,
    lastInteraction: 'hace 10s',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Rock%20radio%20studio%20with%20electric%20guitars%20on%20wall%20band%20posters%20dark%20moody%20lighting%20with%20red%20accents%20vintage%20microphones%20rebellious%20creative%20atmosphere%20industrial%20design&width=160&height=160&seq=sa57-radio-thumb-09&orientation=squarish',
    programs: [
      { id: 10, name: 'Ruta Rock', host: 'Diego Ramírez', startTime: '17:00', endTime: '21:00' },
    ],
    broadcasters: [
      { id: 18, name: 'Diego Ramírez', role: 'Rockero al Aire', photoUrl: 'https://readdy.ai/api/search-image?query=Passionate%20male%20rock%20radio%20DJ%20band%20t%20shirt%20leather%20jacket%20guitar%20in%20background%20rebel%20style%20studio%20setting%20moody%20light&width=160&height=160&seq=sa57-bc-18&orientation=squarish' },
      { id: 19, name: 'Laura Santamaría', role: 'Curadora Musical', photoUrl: 'https://readdy.ai/api/search-image?query=Female%20rock%20music%20curator%20with%20record%20collection%20alternative%20fashion%20style%20vinyl%20records%20creative%20studio%20space%20warm%20lighting&width=160&height=160&seq=sa57-bc-19&orientation=squarish' },
    ],
  },
  {
    id: 10,
    name: 'Radio Clásica',
    frequency: '100.3 FM',
    category: 'Música Clásica / Cultura',
    activityScore: 72,
    interactionScore: 65,
    currentListeners: 1850,
    status: 'on-air',
    upTime: '9h 15m',
    chatMsgCount: 920,
    lastInteraction: 'hace 2m',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20music%20radio%20studio%20grand%20piano%20in%20corner%20sheet%20music%20stands%20rich%20burgundy%20and%20gold%20accents%20soft%20diffused%20lighting%20refined%20cultural%20atmosphere&width=160&height=160&seq=sa57-radio-thumb-10&orientation=squarish',
    programs: [
      { id: 11, name: 'Tardes de Concierto', host: 'Ana Lucía Vargas', startTime: '10:00', endTime: '19:00' },
    ],
    broadcasters: [
      { id: 20, name: 'Ana Lucía Vargas', role: 'Musicóloga', photoUrl: 'https://readdy.ai/api/search-image?query=Refined%20female%20classical%20music%20radio%20host%20elegant%20attire%20sitting%20by%20grand%20piano%20warm%20intellectual%20ambiance%20soft%20light&width=160&height=160&seq=sa57-bc-20&orientation=squarish' },
    ],
  },
  {
    id: 11,
    name: 'Radio Juvenil FM',
    frequency: '104.1 FM',
    category: 'Música / Juvenil',
    activityScore: 86,
    interactionScore: 93,
    currentListeners: 4080,
    status: 'live-show',
    upTime: '2h 50m',
    chatMsgCount: 3450,
    lastInteraction: 'hace 2s',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Trendy%20youth%20radio%20studio%20with%20LED%20ring%20lights%20social%20media%20screens%20vibrant%20pink%20and%20cyan%20colors%20bean%20bags%20modern%20creator%20aesthetic%20energetic%20teen%20vibe&width=160&height=160&seq=sa57-radio-thumb-11&orientation=squarish',
    programs: [
      { id: 12, name: 'La Hora Joven', host: 'Tomás Navarro', startTime: '17:30', endTime: '21:00' },
    ],
    broadcasters: [
      { id: 21, name: 'Tomás Navarro', role: 'Influencer / Locutor', photoUrl: 'https://readdy.ai/api/search-image?query=Young%20trendy%20male%20radio%20host%20streetwear%20fashion%20confident%20pose%20at%20modern%20studio%20social%20media%20vibe%20colorful%20lighting&width=160&height=160&seq=sa57-bc-21&orientation=squarish' },
      { id: 22, name: 'Renata Suárez', role: 'Community Manager al Aire', photoUrl: 'https://readdy.ai/api/search-image?query=Young%20female%20social%20media%20manager%20in%20studio%20phone%20in%20hand%20trendy%20casual%20outfit%20vibrant%20background%20energetic%20pose&width=160&height=160&seq=sa57-bc-22&orientation=squarish' },
    ],
  },
  {
    id: 12,
    name: 'Radio Noticias 24',
    frequency: '97.9 FM',
    category: 'Noticias',
    activityScore: 90,
    interactionScore: 72,
    currentListeners: 3580,
    status: 'on-air',
    upTime: '10h 25m',
    chatMsgCount: 1280,
    lastInteraction: 'hace 1m',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Serious%20news%20radio%20studio%20with%20multiple%20monitor%20screens%20world%20map%20backdrop%20professional%20broadcast%20desk%20cool%20white%20lighting%20breaking%20news%20ticker%20journalistic%20atmosphere&width=160&height=160&seq=sa57-radio-thumb-12&orientation=squarish',
    programs: [
      { id: 13, name: 'Informativo Central', host: 'Lucas Fernández', startTime: '12:00', endTime: '20:00' },
    ],
    broadcasters: [
      { id: 23, name: 'Lucas Fernández', role: 'Periodista Senior', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20male%20news%20anchor%20in%20radio%20studio%20suit%20serious%20expression%20papers%20and%20microphone%20journalistic%20integrity%20clean%20lighting&width=160&height=160&seq=sa57-bc-23&orientation=squarish' },
      { id: 24, name: 'Sofía Montoya', role: 'Reportera', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20reporter%20with%20headset%20notepad%20in%20hand%20newsroom%20background%20alert%20expression%20clean%20lighting&width=160&height=160&seq=sa57-bc-24&orientation=squarish' },
    ],
  },
];

export const liveRadiosStats = {
  totalLiveRadios: 12,
  totalLiveListeners: liveRadios.reduce((s, r) => s + r.currentListeners, 0),
  totalLivePrograms: liveRadios.reduce((s, r) => s + r.programs.length, 0),
  totalLiveBroadcasters: liveRadios.reduce((s, r) => s + r.broadcasters.length, 0),
  totalChatMsgs: liveRadios.reduce((s, r) => s + r.chatMsgCount, 0),
  averageInteraction: Math.round(liveRadios.reduce((s, r) => s + r.interactionScore, 0) / liveRadios.length),
};

export type SortMode = 'activity' | 'interaction' | 'listeners';